import React, { Component } from 'react';
import { Button, Checkbox } from 'react-bootstrap';
import { hubAccessLevels } from '../../constant/config';
import { dateCompare } from '../../lib/utilities';
import Section from './Section';
import './HomeTab.css';
import config from '../../constant/config';
import './ModulesTab.css';
import { IconContext } from 'react-icons';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';

class ModuleTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCategories: [],
      filterTags: [],
      selectedTags: [],
      selectedModuleIds: [],
      searchInput: '',
      sortOrder: 'desc',
      selectedAccessLevel: []
    };
  }

  // --- Helper Methods ---
  getAllNonQuizModuleIds = () =>
    this.props.modules
      .filter((mod) => mod.categoryId !== 3)
      .map((mod) => mod.id);

  getSortedModules = () => [...this.props.modules].sort(dateCompare);

  getModulesBySelectedIds = (modules) =>
    modules.filter((m) => this.state.selectedModuleIds.includes(m.id));

  async fetchFilterData(hubId) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubId}/getFilterData`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      });

      if (res.status === 200) {
        const data = await res.json();
        const categories = data.categories.map((cat) => ({
          id: cat.id,
          categoryName: cat.categoryName,
          expanded: true
        }));
        this.setState({
          filterCategories: categories,
          filterTags: data.tags
        });
      } else {
        console.log('Error fetching filter data');
      }
    } catch (err) {
      console.log('Error fetching filter data', err);
    }
  }

  // --- Lifecycle ---
  async componentDidMount() {
    const hubId = this.props.hub.id;
    if (hubId) {
      await this.fetchFilterData(hubId);
      this.setState({ selectedModuleIds: this.getAllNonQuizModuleIds() });
    }
  }

  // --- Event Handlers ---
  changeTheExpandStatus = (categoryId) => {
    this.setState((prevState) => ({
      filterCategories: prevState.filterCategories.map((cat) =>
        cat.id === categoryId ? { ...cat, expanded: !cat.expanded } : cat
      )
    }));
  };

  onClickClear = () => {
    this.setState(
      {
        selectedTags: [],
        selectedModuleIds: this.getAllNonQuizModuleIds()
      },
      () => {
        //Using the module reference to scroll to the top when the clear button is pressed in filter.
        if (this.moduleListRef) {
          this.moduleListRef.scrollTop = 0;
        }
      }
    );
  };

  onChangeSelection = (tagId) => {
    this.setState(
      (prevState) => {
        const isSelected = prevState.selectedTags.includes(tagId);
        const newSelectedTags = isSelected
          ? prevState.selectedTags.filter((id) => id !== tagId)
          : [...prevState.selectedTags, tagId];

        let selectedModuleIds;
        if (newSelectedTags.length === 0) {
          selectedModuleIds = this.getAllNonQuizModuleIds();
        } else {
          const moduleTagMap = new Map();
          this.props.tagList.forEach(({ tagId, moduleId }) => {
            if (!moduleTagMap.has(moduleId)) {
              moduleTagMap.set(moduleId, new Set());
            }
            moduleTagMap.get(moduleId).add(tagId);
          });

          selectedModuleIds = Array.from(moduleTagMap.entries())
            .filter(([_, tagSet]) =>
              newSelectedTags.every((tag) => tagSet.has(tag))
            )
            .map(([moduleId]) => moduleId);
        }

        return {
          selectedTags: newSelectedTags,
          selectedModuleIds
        };
        // if there is any change to the modules Ref, then automatically it moves to the top
      },
      () => {
        if (this.moduleListRef) {
          this.moduleListRef.scrollTop = 0;
        }
      }
    );
  };

  // --- Render Helpers ---
  getNoModuleContent() {
    if (
      this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN &&
      this.props.fromHomeTab
    ) {
      return (
        <div className="no-modules">
          <div className="no-module-text">
            This hub does not have any modules yet. To get started, create your
            first module in the Create tab above.
          </div>
        </div>
      );
    } else if (this.props.user && this.props.fromHomeTab) {
      return (
        <div className="no-modules">
          It looks like the hub admins have not added any modules yet. Please
          check back later.
        </div>
      );
    } else if (!this.props.user) {
      return (
        <div className="no-modules">
          It looks like the hub admins have not added any public modules yet.
          Please check back later.
        </div>
      );
    }
  }

  getNoQuizContent() {
    if (
      this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN &&
      !this.props.fromHomeTab &&
      !this.props.forumTabFlag
    ) {
      return (
        <div className="no-modules">
          <div className="no-module-text">
            This hub does not have any quizzes yet. To get started, create your
            first quiz in the Create tab above.
          </div>
        </div>
      );
    }
  }
  getNoForumContent() {
    if (
      this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN &&
      this.props.forumTabFlag
    ) {
      return (
        <div className="no-modules">
          <div className="no-module-text">
            This hub does not have any forums yet. To get started, create your
            first forum in the Create tab above.
          </div>
        </div>
      );
    } else if (this.props.user && this.props.forumTabFlag) {
      return (
        <div className="no-modules">
          It looks like the hub admins have not added any forums yet. Please
          check back later.
        </div>
      );
    } else if (!this.props.user) {
      return (
        <div className="no-modules">
          It looks like the hub admins have not added any public forums yet.
          Please check back later.
        </div>
      );
    }
  }

  handleSearch = (event) => {
    this.setState({ searchInput: event.target.value });
  };

  handleSortByName = (modules) => {
    const { sortOrder } = this.state;

    const sortedModules = [...modules].sort((a, b) => {
      const elementA = a.title.toLowerCase();
      const elementB = b.title.toLowerCase();

      if (sortOrder === 'asc') {
        return elementA.localeCompare(elementB);
      } else {
        return elementB.localeCompare(elementA);
      }
    });

    return sortedModules;
  };
  updateSelectedAccessId(accessId) {
    const oldList = this.state.selectedAccessLevel;

    if (oldList.includes(accessId)) {
      const newList = oldList.filter((aid) => aid !== accessId);
      this.setState({ selectedAccessLevel: newList });
    } else {
      this.setState({ selectedAccessLevel: [...oldList, accessId] });
    }
  }

  render() {
    const modulesSorted = this.getSortedModules();
    let informationModulesFiltered = this.handleSortByName(
      this.getModulesBySelectedIds(
        modulesSorted.filter(
          (mod) => mod.categoryId !== 3 && mod.categoryId !== 4
        )
      )
    ).filter((modules) =>
      modules.title.toLowerCase().includes(this.state.searchInput.toLowerCase())
    );
    if (this.state.selectedAccessLevel.length != 0) {
      informationModulesFiltered = informationModulesFiltered.filter((module) =>
        this.state.selectedAccessLevel.includes(module.accessId)
      );
    }
    const quizModulesFiltered = modulesSorted.filter(
      (mod) => mod.categoryId === 3
    );
    const forumModulesFiltered = modulesSorted.filter(
      (mod) => mod.categoryId === 4
    );

    const message =
      informationModulesFiltered.length === 0
        ? 'No results for the filter options you have chosen. Try broadening your search to find relevant modules.'
        : this.state.selectedTags.length === 0
        ? 'Build your custom toolkit: To get started, use the filtering options to explore tailored approaches that suit your individual context.'
        : '';

    return (
      <div
        className={
          this.props.fromHomeTab
            ? 'modules-tab-main-container'
            : 'quiz-tab-main-container'
        }
      >
        {/* Sidebar */}
        {this.props.hub.active_filter != false && this.props.fromHomeTab && this.state.filterCategories.length > 0 && (
          <div className="modules-side-bar">
            <div style={{ height: '80vh', overflowY: 'scroll' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '20px'
                }}
              >
                Filter
              </div>
              {this.state.filterCategories.map((cat) => (
                <div key={cat.id} style={{ padding: '1em 1em 0 0em' }}>
                  <div className="filter-category-title">
                    <p>{cat.categoryName}</p>
                    <Button onClick={() => this.changeTheExpandStatus(cat.id)}>
                      <IconContext.Provider
                        value={{
                          style: {
                            color: 'var(--color-background-darkest-role)',
                            size: '150px'
                          }
                        }}
                      >
                        {cat.expanded ? <FaCaretDown /> : <FaCaretRight />}
                      </IconContext.Provider>
                    </Button>
                  </div>
                  <hr />
                  {cat.expanded && (
                    <div className="filter-tag-main-container">
                      {this.state.filterTags
                        .filter((tag) => tag.categoryid === cat.id)
                        .map((filteredTag) => (
                          <div
                            key={filteredTag.id}
                            className="filter-tag-container"
                          >
                            <div className="tag-name">
                              {filteredTag.tagName}
                            </div>
                            <Checkbox
                              className="checkbox"
                              onChange={() =>
                                this.onChangeSelection(filteredTag.id)
                              }
                              checked={this.state.selectedTags.includes(
                                filteredTag.id
                              )}
                            />
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '2em'
                }}
              >
                <Button className="clear-button" onClick={this.onClickClear}>
                  Clear All
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Content */}

        {!this.props.modules.length && this.getNoModuleContent()}
        {!quizModulesFiltered.length &&
          !this.props.forumTabFlag &&
          !this.props.fromHomeTab &&
          this.getNoQuizContent()}
        {!forumModulesFiltered.length &&
          this.props.forumTabFlag &&
          this.getNoForumContent()}
        {modulesSorted.length > 0 && this.props.fromHomeTab && (
          <div
            className="home-tab-container"
            style={{ flex: '1', height: '80vh', overflowY: 'scroll' }}
            //Creating a reference for the module list to understand the change in its state
            ref={(ref) => (this.moduleListRef = ref)}
          >
            <div className="section">
              {this.props.hub.id !== 346 && this.props.modules.length && <div className="parent-search-accessbutton-container">
                <div
                  className="searchbox-sort"
                  style={{
                    display: 'flex',
                    justifySelf: 'center',
                    marginTop: '15px'
                  }}
                >
                  <div
                    className="search-box-div"
                    style={{
                      display: 'flex',
                      position: 'relative'
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search Modules within this Hub..."
                      value={this.state.searchInput}
                      onChange={this.handleSearch}
                      style={{
                        marginTop: '5px',
                        fontSize: '16px',
                        width: '500px',
                        borderRadius: '20px',
                        paddingLeft: '20px',
                        outline: 'none'
                      }}
                    />
                    {this.state.searchInput && (
                      <i
                        className="bi bi-x-circle-fill"
                        onClick={() => this.setState({ searchInput: '' })}
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: '55%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          color: '#9a9799ff',
                          fontSize: '25px'
                        }}
                        title="Clear search"
                      >
                        {' '}
                      </i>
                    )}
                  </div>
                  <Button
                    variant="link"
                    onClick={() => {
                      this.setState({
                        sortOrder:
                          this.state.sortOrder === 'asc' ? 'desc' : 'asc'
                      });
                    }}
                    style={{
                      //  padding: '0 5px',
                      fontSize: '25px',
                      fontWeight: 'bold',
                      color: '#14B4C8'
                    }}
                  >
                    <i
                      className={`bi ${
                        this.state.sortOrder === 'asc'
                          ? 'bi-sort-alpha-up'
                          : 'bi-sort-alpha-down'
                      }`}
                      //  style={{ }}
                    ></i>
                  </Button>
                </div>
                {this.props.hub.userAccessLevel >=
                  hubAccessLevels.HUB_ADMIN && (
                  <div className="access-buttons-container">
                    <Button
                      className={
                        this.state.selectedAccessLevel.includes(1)
                          ? 'access-button-selected'
                          : 'access-button-unselected'
                      }
                      onClick={() => this.updateSelectedAccessId(1)}
                    >
                      Public
                    </Button>
                    <Button
                      className={
                        this.state.selectedAccessLevel.includes(2)
                          ? 'access-button-selected'
                          : 'access-button-unselected'
                      }
                      onClick={() => this.updateSelectedAccessId(2)}
                    >
                      Private
                    </Button>
                    <Button
                      className={
                        this.state.selectedAccessLevel.includes(3)
                          ? 'access-button-selected'
                          : 'access-button-unselected'
                      }
                      onClick={() => this.updateSelectedAccessId(3)}
                    >
                      Hidden
                    </Button>
                    <Button
                      className={
                        this.state.selectedAccessLevel.includes(4)
                          ? 'access-button-selected'
                          : 'access-button-unselected'
                      }
                      onClick={() => this.updateSelectedAccessId(4)}
                    >
                      Course Only
                    </Button>
                  </div>
                )}
              </div>}
            </div>
            <Section
              context="modules"
              tiles={informationModulesFiltered}
              small
              moduleTab
              user={this.props.user}
              bookmarks={this.props.bookmarks}
              message={message}
              active_filter={this.props.hub.active_filter}
            />
          </div>
        )}

        <div></div>
        {quizModulesFiltered.length > 0 &&
          this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN &&
          !this.props.fromHomeTab &&
          this.props.forumTabFlag != true && (
            <div className="home-tab-container">
              <div className="section">
                <Section
                  context="modules"
                  title="Quizzes"
                  tiles={quizModulesFiltered}
                  small
                  moduleTab
                  user={this.props.user}
                  bookmarks={this.props.bookmarks}
                  fromQuizorForum={true}
                />
              </div>
            </div>
          )}
        {forumModulesFiltered.length > 0 && this.props.forumTabFlag == true && (
          <div className="home-tab-container">
            <div className="section">
              <Section
                context="modules"
                title="Forums"
                tiles={forumModulesFiltered}
                small
                moduleTab
                user={this.props.user}
                bookmarks={this.props.bookmarks}
                fromQuizorForum={true}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ModuleTab;
